import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import NotFound from '@/components/NotFound'

import globals from '@/globals'

// Layouts
import Layout2 from '@/layout/Layout2'
import Layout2Flex from '@/layout/Layout2Flex'
import LayoutBlank from '@/layout/LayoutBlank'
// Vuex store
import store from '../store'

Vue.use(Router)
Vue.use(Meta)

const ROUTES = [
  // Default route
  {
    path: '',
    redirect: '/dashboards/dashboard-1'
  }, {
    path: '/dashboards',
    component: Layout2,
    children: [{
      path: 'dashboard-1',
      component: () => import('@/components/Dashboard1')
    }]
  }, {
    path: '/',
    component: LayoutBlank,
    children: [{
      path: 'login',
      component: () => import('@/components/Login')
    }, {
      path: 'recover',
      component: () => import('@/components/PasswordChange')
    }]
  }, {
    path: '/inventory',
    component: Layout2,
    children: [{
      path: 'product-list',
      component: () => import('@/components/inventory/InventoryProductList')
    }, {
      path: 'product-item',
      component: () => import('@/components/inventory/ProductItem')
    }, {
      path: 'product-item/edit',
      component: () => import('@/components/inventory/ProductItemEdit')
    }, {
      path: 'product-item/create',
      component: () => import('@/components/inventory/ProductItemEdit')
    }, {
      path: 'inventory-operation-list',
      component: () => import('@/components/inventory/InventoryOperationList')
    }, {
      name: 'inventory-operation',
      path: 'inventory-operation',
      component: () => import('@/components/inventory/InventoryOperation')
    }, {
      path: 'shipping-order-list',
      component: () => import('@/components/inventory/ShippingOrderList')
    }, {
      path: 'shipping-order-new',
      component: () => import('@/components/inventory/ShippingOrderNew')
    }, {
      path: 'shipping-order-item',
      component: () => import('@/components/inventory/ShippingOrderItem')
    }]
  }, {
    path: '/sales',
    component: Layout2Flex,
    children: [{
      path: 'pos',
      component: () => import('@/components/sales/pos')
    }]
  }, {
    path: '/sales',
    component: Layout2,
    children: [{
      path: 'sales-list',
      component: () => import('@/components/sales/SalesList')
    }, {
      path: 'sales-order',
      component: () => import('@/components/sales/SaleOrder')
    }, {
      path: 'cash-close',
      component: () => import('@/components/sales/CashClose')
    }, {
      path: 'customer-list',
      component: () => import('@/components/sales/CustomerList')
    }, {
      path: 'customer',
      component: () => import('@/components/sales/CustomerView')
    }, {
      path: 'customer-create',
      component: () => import('@/components/sales/CustomerEdit')
    }, {
      path: 'customer-edit',
      component: () => import('@/components/sales/CustomerEdit')
    }]
  }, {
    path: '/config',
    component: Layout2,
    children: [{
      path: 'user-list',
      component: () => import('@/components/config/UserList')
    }, {
      path: 'user-edit',
      component: () => import('@/components/config/UserEdit')
    }, {
      path: 'category-list',
      component: () => import('@/components/config/CategoryList')
    }, {
      path: 'financial-account-list',
      component: () => import('@/components/config/FinancialAccountList')
    }, {
      path: 'api-key-list',
      component: () => import('@/components/config/ApiKeyList')
    }, {
      path: 'api-key-create',
      component: () => import('@/components/config/ApiKeyEdit')
    }, {
      path: 'api-key-edit',
      component: () => import('@/components/config/ApiKeyEdit')
    }]
  }, {
    path: '/reports',
    component: Layout2,
    children: [{
      path: 'inventario',
      component: () => import('@/components/reports/InventoryReport')
    }, {
      path: 'ventas',
      component: () => import('@/components/reports/SalesReport')
    }, {
      path: 'operaciones',
      component: () => import('@/components/reports/FinancialReport')
    }]
  }, {
    // 404 Not Found page
    path: '*',
    component: NotFound
  }
]

const router = new Router({
  base: '/',
  mode: 'history',
  routes: ROUTES
})

router.afterEach(() => {
  // Remove initial splash screen
  const splashScreen = document.querySelector('.app-splash-screen')
  if (splashScreen) {
    splashScreen.style.opacity = 0
    setTimeout(() => {
      if (splashScreen.parentNode) {
        splashScreen && splashScreen.parentNode.removeChild(splashScreen)
      }
    }, 300)
  }
  // On small screens collapse sidenav
  if (window.layoutHelpers && window.layoutHelpers.isSmallScreen() && !window.layoutHelpers.isCollapsed()) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
  }

  // Scroll to top of the page
  globals().scrollTop(0, 0)
})

router.beforeEach((to, from, next) => {
  // Set loading state
  document.body.classList.add('app-loading')

  if (to.path !== '/login' && to.path.indexOf('/recover') < 0) {
    if (!store.getters.isAuthenticated) {
      console.log('[index.js router] not authenticated, redirecting to login')
      next('/login')
      return
    }
  }
  // Add tiny timeout to finish page transition
  setTimeout(() => next(), 10)
})

export default router
